/*
 * @Author: your name
 * @Date: 2021-09-15 11:35:43
 * @LastEditTime: 2021-09-15 13:41:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\routes\modules\targetManagement.js
 */
export default [
  {
    name: "targetTree",
    path: "/targetManagement/targetTree",
    component: () => import("@/views/targetManagement/index.vue"),
    meta: {
      title: "指标树",
    },
  },
];
